module.exports = __webpack_public_path__ + "img/i3.c907e80f.png";